import { render, staticRenderFns } from "./HistoryPopup.vue?vue&type=template&id=4c2a0c34&scoped=true"
import script from "./HistoryPopup.vue?vue&type=script&lang=js"
export * from "./HistoryPopup.vue?vue&type=script&lang=js"
import style0 from "./HistoryPopup.vue?vue&type=style&index=0&id=4c2a0c34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2a0c34",
  null
  
)

export default component.exports